(function () {
  'use strict';
  class Controller {
    constructor() {}
  }
  angular
    .module('supplier.metadata', [])
    .component('supplierMetadata', {
      controller: Controller,
      templateUrl: 'root/supplier/_components/metadata/metadata-supplier.comp.html',
      bindings: {
        supplierId: '<'
      }
    });
}());
